import { useState, useEffect, get, useLocation, forwardRef } from '@/common'
import { Modal, Space, Table, Button, Input, message } from 'antd';
import './SearchAdd.scss';

function Main(props: any, ref: any) {
    const location = useLocation()
    const pathname = props.apiUrl || location.pathname
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [search_rs, setSearchRs] = useState([])
    const [data, setData] = useState<any>([])
    const [search_value, setSearchValue] = useState('')
    const [selected_row_keys, setSelectedRowKeys] = useState([]);
    const [selected_row, setSelectedRows] = useState([]);
    const [default_status, setDefaultStatus] = useState(true)

    const onChange = (datas: any) => {
        // setDefaultStatus(false)
        setData([...datas])
        if (datas.length) {
            props.onChange(datas)
        } else {
            props.onChange(null)
        }
        if (props.onChanged && typeof (props.onChanged) == "function") props.onChanged(datas)
    }

    useEffect(() => {
        // 执行一次
        if (default_status && props.value) {
            setData(props.value)
            setDefaultStatus(false)
        }
        // if (props.value && default_status) setDatas(props.value)
    }, [props])

    return (
        <div className='search_add'>
            <div className='top'>
                <Button type="primary" onClick={() => {
                    setOpen(true)
                    setSearchValue('')
                    setSearchRs([])
                    setSelectedRowKeys([])
                }} size='small'>添加{props.title}</Button>
            </div>
            <Table
                columns={[...props.columns, {
                    title: '操作',
                    align: 'center',
                    render: (text: string, record: any, index: number) => (
                        <Space>
                            {
                                index > 0 && <Button type="link" size="small" onClick={() => {
                                    data.splice(index, 1)
                                    data.splice(index - 1, 0, record)
                                    onChange(data)
                                }}>上移</Button>
                            }
                            {
                                index < data.length - 1 && <Button type="link" size="small" onClick={() => {
                                    data.splice(index, 1)
                                    data.splice(index + 1, 0, record)
                                    onChange(data)
                                }}>下移</Button>
                            }
                            <Button type="link" danger size="small" onClick={() => {
                                data.splice(index, 1)
                                onChange(data)
                            }}>删除</Button>
                        </Space>
                    )
                }]}
                dataSource={data}
                size="small"
                rowKey='id'
                pagination={false}
            />
            <Modal open={open} title={`选择${props.title}`} onCancel={() => { setOpen(false) }} width={props.width || undefined} onOk={() => {
                let have = false
                data.forEach((e: any) => {
                    if (e.id === selected_row_keys[0]) {
                        have = true
                    }
                })
                if (have) {
                    message.error('该数据已存在')
                    return
                }
                onChange([...data, ...selected_row])
                setOpen(false)
            }}>
                <div className='modal_top'>
                    <Input value={search_value} placeholder='请输入账号/姓名/手机号搜索' onInput={(data: any) => {
                        setSearchValue(data.target.value)
                    }} />
                    <Button type="primary" onClick={() => {
                        get(props.action, {
                            filter: search_value
                        }).then(data => {
                            setSearchRs(data.data)
                        })
                    }}>搜索</Button>
                </div>
                <Table
                    columns={props.searchColumns}
                    dataSource={search_rs}
                    pagination={false}
                    size="small"
                    rowSelection={{
                        type: 'radio',
                        selectedRowKeys: selected_row_keys,
                        onChange: (selectedRowKeys: any, selectedRows: any) => {
                            setSelectedRowKeys(selectedRowKeys)
                            setSelectedRows(selectedRows)
                        }
                    }}
                    rowKey='id'
                />
            </Modal>
        </div>
    )
}
export default forwardRef(Main)